const WarningDiamondIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.9995 20.9654H16.0128"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.48281"
      />
      <path
        d="M5.09477 13.3572L13.3573 5.09465C14.8169 3.63512 17.1832 3.63512 18.6428 5.09465L26.9053 13.3572C28.3648 14.8167 28.3648 17.1831 26.9053 18.6426L18.6428 26.9052C17.1832 28.3647 14.8169 28.3647 13.3573 26.9052L5.09477 18.6426C3.63524 17.1831 3.63524 14.8167 5.09477 13.3572Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.48281"
      />
      <path
        d="M15.9995 10.6207V16.4137"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.48281"
      />
    </svg>
  )
}

export default WarningDiamondIcon
